import { graphql } from '~/graphql';
import { useGraphqlQuery } from '~/hooks/useGraphqlQuery';

export const useGetLocations = () => {
  const locationsQuery = graphql(`
    query locations {
      locations {
        id
        name
      }
    }
  `);

  return useGraphqlQuery(locationsQuery, ['locations']);
};
